import { FC, useEffect, useState } from "react";
import cx from "classnames";
import { useFormatter, useTranslations } from "next-intl";
import { useSelector } from "react-redux";
import { I18N_NAMESPACE } from "@/config/i18n";
import SVGIcon from "../SVGIcon";
import { IFavoriteGameViewModel } from "../../fe-core-omega/meta/interfaces/user";
import { userBalanceDataSelector } from "../../fe-core-omega/_redux/selectors/userSelectors";
import { subscribe } from "../../fe-core-omega/helpers/liveLobby";
import { ICasinoGameViewModel, ICasinoGroupGameViewModel } from "../../fe-core-omega/meta/interfaces/casino";

interface LiveLobbyDetailsProps {
  game:
    | ICasinoGroupGameViewModel
    | IFavoriteGameViewModel
    | ICasinoGameViewModel;
}

const LiveLobbyDetails: FC<LiveLobbyDetailsProps> = ({ game }) => {
  const format = useFormatter();
  const t = useTranslations(I18N_NAMESPACE.GAME_CARD);
  const { totalCurrency: currency } =
    useSelector(userBalanceDataSelector) || {};

  const [rouletteNumbers, setRouletteNumbers] = useState(
    game?.details?.currentRouletteNumbers ?? []
  );

  const [tableData, setTableData] = useState(game?.details ?? {});

  const wheel = [
    1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36,
  ];

  // console.log("game?.name", game?.name);
  // console.log("game", game);

  // useEffect(() => {
  //   if (game?.liveCasinoCategory) {
  //     const callback = (incomingDetails: any) => {
  //       switch (incomingDetails?.MessageType) {
  //         case "RouletteResultsUpdated":
  //           setRouletteNumbers((prevState: any) => {
  //             // here check for equality and return prevState if the same. this prevents rerenders
  //             return JSON.stringify(incomingDetails.Results) ===
  //               JSON.stringify(prevState)
  //               ? prevState
  //               : incomingDetails.Results;
  //           });
  //           break;
  //         case "SeatsUpdated":
  //           // console.log("incomingDetails", incomingDetails);
  //           // console.log("game?.name", game?.name);

  //           setTableData((prevState: any) => {
  //             return JSON.stringify(incomingDetails) ===
  //               JSON.stringify(prevState)
  //               ? prevState
  //               : {
  //                   ...prevState,
  //                   currentOccupiedSeats: incomingDetails?.Seats,
  //                 };
  //           });
  //       }
  //     };
  //     const evtSource = subscribe(game.vendor.name, game?.id, callback);
  //     return () => {
  //       evtSource.close();
  //     };
  //   }
  // }, []);
  // console.log(tableData, "tableData");
  if (
    !game?.details &&
    !rouletteNumbers &&
    !tableData
  )
    return;
  return (
    <>
      <div className="">
        {rouletteNumbers && Array.isArray(rouletteNumbers) && (
          <div
            className={` flex items-center justify-center left-0 md:space-x-1 space-x-0.5 w-full `}
          >
            {rouletteNumbers?.slice(-6)?.map((item, index) => (
              <div
                key={`TableDetails____${index}`}
                className={cx(
                  `md:w-5 md:h-5 w-5 h-5 rounded-full transform transition-all flex items-center justify-center duration-300  text-[9px] text-center md:leading-3 leading-none scale-100 font-semibold border border-transparent  `,
                  {
                    "dark:bg-error-300 bg-error-500 text-white":
                      wheel.includes(Number(item)) && Number(item) !== 0,
                    "bg-black text-white":
                      !wheel.includes(Number(item)) && Number(item) !== 0,
                    "dark:bg-green-300 bg-green-500 text-white":
                      Number(item) === 0,
                  }
                )}
              >
                {item}
              </div>
            ))}
          </div>
        )}
        {tableData?.currentOccupiedSeats?.length > 0 && (
          <span className="bg-success-500 absolute top-1.5 right-1.5 dark:bg-success-300 rounded   h-5 text-center flex items-center justify-center text-white font-semibold text-xxs leading-5 px-1.5">
            <SVGIcon icon="user" className="w-2.5 h-3 mr-0.5" />
            {tableData?.currentOccupiedSeats?.length ?? 0}
          </span>
        )}
        <div className="space-y-1">
          {tableData?.totalSeats && tableData?.isOpen && (
            <div className="flex items-center justify-center">
              <p className="text-xs font-bold space-x-1 text-center flex">
                <span>{t("seats-available")}</span>
                <span className="bg-success-500 dark:bg-success-300 px-2 rounded h-5 text-center flex items-center justify-center text-white font-semibold">
                  {tableData.totalSeats -
                    tableData?.currentOccupiedSeats?.length ?? 0}
                </span>
              </p>
            </div>
          )}

          {tableData?.betLimit?.max?.[currency ?? "USD"] &&
            tableData?.betLimit?.min?.[currency ?? "USD"] && (
              <p className="font-medium text-xxs space-x-1 text-center  ">
                {tableData?.betLimit?.min?.[currency ?? "USD"] &&
                  format.number(tableData?.betLimit?.min?.[currency ?? "USD"], {
                    style: "currency",
                    currency: currency ?? "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}{" "}
                -{" "}
                {tableData?.betLimit?.max?.[currency ?? "USD"] &&
                  format.number(tableData?.betLimit?.max?.[currency ?? "USD"], {
                    style: "currency",
                    currency: currency ?? "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
              </p>
            )}
          {tableData?.isOpen === false && (
            <p className="text-xs font-bold space-x-1 text-center text-red-500 dark:text-red-300">
              {t("table-close")}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default LiveLobbyDetails;
